/* Primal Print : pp-port.js, the port layer beside pp.js (the frozen mock's script, verbatim).
   1. gang sheet: the chosen size sets the product form's variant id and every builder link (Gangio's /apps/gang-sheet-builder/builder)
   2. quote form: file list, validation, artwork upload to the Worker (links into contact[Artwork files]), then a NATIVE submit
   3. videos marked data-pp-autoplay play muted only while on screen
   4. a posted contact/quote form scrolls its thank-you panel into view
   Vanilla, no dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. gang sheet size -> variant id + builder links */
  function initGang() {
    var form = document.querySelector('.pp-gs form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    function apply(variantId) {
      if (!variantId) return;
      if (idInput) {
        idInput.value = variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.querySelectorAll('[data-builder-link]').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        a.setAttribute('href', /[?&]variant_id=/.test(href) ? href.replace(/([?&]variant_id=)\d*/, '$1' + variantId) : href + (href.indexOf('?') > -1 ? '&' : '?') + 'variant_id=' + variantId);
      });
    }
    form.addEventListener('change', function (e) {
      var r = e.target.closest('input[data-variant]');
      if (r && r.checked) apply(r.getAttribute('data-variant'));
    });
  }

  /* 2. quote form */
  function initQuote() {
    var form = document.querySelector('[data-pp-quote]');
    if (!form) return;
    var endpoint = form.getAttribute('data-endpoint') || '';
    var maxMb = parseFloat(form.getAttribute('data-max-mb')) || 50;
    var input = form.querySelector('[data-files-input]');
    var list = form.querySelector('[data-files]');
    var drop = form.querySelector('[data-drop]');
    var out = form.querySelector('[data-files-out]');
    var status = form.querySelector('[data-upload-status]');
    var err = form.querySelector('[data-form-error]');
    var allowed = ((input && input.getAttribute('accept')) || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    function extOk(name) {
      if (!allowed.length) return true;
      var dot = name.lastIndexOf('.');
      return dot > -1 && allowed.indexOf(name.slice(dot).toLowerCase()) > -1;
    }
    function fileProblem(f) {
      if (!extOk(f.name)) return 'file type not accepted';
      if (f.size > maxMb * 1048576) return 'over ' + maxMb + ' MB';
      return '';
    }
    if (input) {
      input.addEventListener('change', function () {
        list.innerHTML = '';
        Array.prototype.forEach.call(input.files, function (f) {
          var li = document.createElement('li');
          var p = fileProblem(f);
          li.textContent = f.name + ' · ' + Math.max(1, Math.round(f.size / 1024)) + ' KB' + (p ? ' · ' + p : '');
          if (p) li.className = 'is-bad';
          list.appendChild(li);
        });
      });
      ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.remove('is-over'); }); });
    }

    function showError(msg, el) {
      if (err) { err.textContent = msg; err.hidden = false; }
      if (el && el.focus) el.focus({ preventScroll: true });
      (el || err).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
    function validate() {
      var req = form.querySelectorAll('input[required], select[required], textarea[required]');
      for (var i = 0; i < req.length; i++) {
        var f = req[i];
        if (!String(f.value || '').trim() || (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value.trim()))) {
          var lab = form.querySelector('label[for="' + f.id + '"]');
          return showError('Please fill in: ' + (lab ? lab.textContent.replace('*', '').trim() : 'the highlighted field') + '.', f), false;
        }
      }
      var groups = form.querySelectorAll('[data-group-required]');
      for (var g = 0; g < groups.length; g++) {
        if (!groups[g].querySelector('input:checked')) {
          var lg = groups[g].querySelector('legend');
          return showError('Please choose at least one: ' + (lg ? lg.textContent.replace('*', '').trim() : 'option') + '.', groups[g].querySelector('input')), false;
        }
      }
      var sz = form.querySelector('[data-sizes-required]');
      if (sz) {
        var total = 0;
        sz.querySelectorAll('input').forEach(function (n) { total += Math.max(0, parseInt(n.value, 10) || 0); });
        var more = form.querySelector('#q-moresizes');
        if (!total && !(more && more.value.trim())) return showError('Please enter how many of each size you need.', sz.querySelector('input')), false;
      }
      if (input) {
        if (!input.files.length && !input.hasAttribute('data-files-optional')) return showError('Please add your ' + (input.id === 'q-files' ? 'artwork files' : 'photos') + '.', input), false;
        for (var k = 0; k < input.files.length; k++) {
          var pr = fileProblem(input.files[k]);
          if (pr) return showError(input.files[k].name + ': ' + pr + '.', input), false;
        }
      }
      return true;
    }
    function upload(file, i, n) {
      if (status) status.textContent = 'Uploading ' + (i + 1) + ' of ' + n + ': ' + file.name;
      var fd = new FormData();
      fd.append('file', file, file.name);
      fd.append('email', (form.querySelector('[name="contact[email]"]') || {}).value || '');
      return fetch(endpoint, { method: 'POST', body: fd }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.ok) throw new Error(j.error || ('upload failed (' + r.status + ')'));
          return file.name + ' : ' + j.url;
        });
      });
    }

    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-pp-ready') === '1') return; /* files done: let Shopify's own handlers (spam check) run */
      e.preventDefault();
      if (err) err.hidden = true;
      if (!validate()) return;
      form.classList.add('is-sending');
      var files = input ? Array.prototype.slice.call(input.files) : [];
      var lines = [];
      var chain = Promise.resolve();
      files.forEach(function (f, i) { chain = chain.then(function () { return upload(f, i, files.length).then(function (l) { lines.push(l); }); }); });
      chain.then(function () {
        if (out) out.value = lines.join('\n');
        if (status) status.textContent = files.length ? 'Files uploaded. Sending your request...' : '';
        form.setAttribute('data-pp-ready', '1');
        if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
      }).catch(function (x) {
        form.classList.remove('is-sending');
        if (status) status.textContent = '';
        showError('One of your files did not upload (' + x.message + '). Please try again, or email the artwork to us and send the form without it.', input);
      });
    });
  }

  /* 3. videos play only while visible */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-pp-autoplay]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
  }

  /* 3b. sticky buy bar: the mock's observer misses an instant jump back to the top (no intersection change), so also check on scroll */
  function initBuyBarSync() {
    var bar = document.querySelector('[data-buybar]');
    var main = document.querySelector('[data-main-buy]');
    if (!bar || !main) return;
    var tick = false;
    function sync() {
      tick = false;
      var past = main.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', String(!past));
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(sync); } }, { passive: true });
    sync();
  }

  /* 4. posted forms */
  function initPosted() {
    var done = document.querySelector('[data-done]');
    if (done && /contact_posted=true/.test(location.search)) {
      done.scrollIntoView({ block: 'center' });
      done.focus({ preventScroll: true });
    }
  }

  function boot() { initGang(); initQuote(); initVideos(); initBuyBarSync(); initPosted(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
